export default {
    "quiz.title": "Interactive quizzes",
    "quiz.title_highlight": "by Theme",
    "quiz.subtitle": "Validate your knowledge chapter by chapter for optimal retention.",

    "quiz.nav.back_themes": "Back to themes",
    "quiz.nav.retry": "Restart quiz",
    "quiz.nav.next": "Next question",
    "quiz.nav.submit": "Submit my answer",
    "quiz.nav.finish": "Finish quiz",
    "quiz.nav.finish_session": "End my session",
    "quiz.nav.quit": "Quit",

    "quiz.mode.qcm.title": "Multiple Choice",
    "quiz.mode.qcm.description": "4 options, only 1 correct answer. The official exam format.",
    "quiz.mode.vrai_faux.title": "True or False",
    "quiz.mode.vrai_faux.description": "Test your knowledge on precise statements.",
    "quiz.mode.locked_pro": "PRO",
    "quiz.mode.upgrade_pro": "UNLOCK FULL ACCESS",
    "quiz.mode.limit_reached": "Limit of {{count}} questions per quiz reached on free version.",

    "quiz.retry_errors.title": "Targeted Review",
    "quiz.retry_errors.subtitle": "You have {{count}} questions awaiting review in this theme.",
    "quiz.retry_errors.qcm": "Retry Multiple Choice",
    "quiz.retry_errors.vrai_faux": "Retry True/False",

    "quiz.status.no_questions": "No questions available",
    "quiz.status.no_questions_desc": "All questions in this mode have been answered correctly! Great job.",
    "quiz.status.question": "Question {{current}} of {{total}}",
    "quiz.status.score": "Score: {{score}}",

    "quiz.vrai_faux.true": "True",
    "quiz.vrai_faux.false": "False",

    "quiz.feedback.correct": "That's correct!",
    "quiz.feedback.incorrect": "That's incorrect.",
    "quiz.feedback.explanation": "Explanation",

    "quiz.result.title": "Quiz completed!",
    "quiz.result.perfect": "Amazing! A perfect score.",
    "quiz.result.good": "Great work! You have a strong grasp of this topic.",
    "quiz.result.average": "Good start. Keep practicing!",
    "quiz.result.bad": "You need a bit more review on this chapter.",
    "quiz.result.stats.questions": "Questions",
    "quiz.result.stats.correct": "Correct",
    "quiz.result.stats.accuracy": "Accuracy",

    "quiz.badges.new": "New Badge!",
    "quiz.badges.congrats": "Congratulations on your consistent efforts.",
    "quiz.badges.close": "Continue"
};
